import React from "react";
import ReactDOM from "react-dom";

const PortalMenu = React.forwardRef(({ children, style, show, close, align, labeledBy, ...props }, ref) => {
 return ReactDOM.createPortal(
 <div ref={ref} style={style} {...props}>
 {children}
 </div>,
 document.body
 );
});

export default PortalMenu;
